"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_final_form_1 = require("react-final-form");
const index_1 = require("../../components/index");
const formatPhoneNumber = (value) => value?.replace(/[^0-9,+]/g, '');
const PhoneField = ({ name, label = 'Phone Number', helperText, validate }) => {
    return (react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate }, ({ input, meta }) => {
        return (react_1.default.createElement(index_1.MaskedInput, { mask: "phone", fullWidth: true, label: label, value: input.value, onChange: (value) => {
                const formattedNumber = formatPhoneNumber(value?.toString());
                input.onChange(formattedNumber);
            }, error: meta.touched && !!meta.error, helperText: meta.touched && !!meta.error ? meta.error : helperText }));
    }));
};
exports.default = PhoneField;
